import { connect } from 'react-redux';
import ResultOptions from './ResultOptions';
import timeDepositActions from '../../../../../store/actions/timeDeposit.action';
import googleAnalytics from '../../../../../store/actions/googleAnalytics.action';

const  mapStateToProps = state => ({
    step: state.simulation.step,
    amount: state.simulation.amount,
    result: state.simulation.result.datosSimulacionDap,
    accounts: state.account.list,
    accountOut: state.simulation.accountOut,
    accountIn: state.simulation.accountIn,
    termsAccepted: state.simulation.termsAccepted,
    email: state.user.email,
    isLoading: state.account.loading,
    challenges: state.challenge.challenges,
    invertible: state.simulation.result.invertible
  });

  const mapDispatchToProps = dispatch => {
    return {
      setStep: step => {
        dispatch(timeDepositActions.setStep(step));
      },
      cleanResult: () => {
        dispatch(timeDepositActions.cleanResult());
      },
      googleAnalytics: (params) => {
        googleAnalytics.registerGoogleAnalytics(params);
      }
    }
  }

  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(ResultOptions);